import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectCompany } from "../features/auth/authSlice";

export const useCompany = () => {
  const company = useSelector(selectCompany);

  return useMemo(() => company, [company]);
};
